import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class BookmakersPromoRedirector {
    private r = inject(Router);


    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): UrlTree {
        return this.r.parseUrl(route.data['@prefix'] + state.url.substring(route.data['@start'])); // slice /bookmakers from old url '/bookmakers/promo/....'
    }
}

